import 'reflect-metadata';
import { Entity, Column, PrimaryGeneratedColumn, OneToMany } from 'typeorm';
import { BaseEntite, EntiteStatique } from '.';
import { EtiquetteCategorie } from './etiquette-categorie.entity';

@EntiteStatique()
@Entity('etiquette')
export class Etiquette implements BaseEntite {
    static key = 'etiquettes';
    @PrimaryGeneratedColumn()
    id: number;
    @Column({ nullable: false })
    name: string;
    @Column({ nullable: true })
    description: string;
    @Column({ nullable: true })
    est_public: string;
    @OneToMany(() => EtiquetteCategorie, (etiquette_categorie: EtiquetteCategorie) => etiquette_categorie.etiquette)
    etiquette_categorie: EtiquetteCategorie[];
}
